import React from "react";

const HeroSection = () => {
  return (
    <section className="Services">
      <div className="bg-image-Services position-relative">
        <div className="bg-overlay-Services position-absolute w-100 h-100 top-0 start-0"></div>
        <div className="container content-Services py-5">
          <div className="row justify-content-center">
            <div className="col text-center">
              <h2>Services</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
